/**
 * Converts a string to title case
 * @param str The string to convert
 * @returns The title-cased string
 */
export const toTitleCase = (str: string): string => {
  return str
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .replace(/\s+/g, " ")
    .trim();
};
